import { render, staticRenderFns } from "./UnitKLNG.vue?vue&type=template&id=1877d8ff&scoped=true&"
import script from "./UnitKLNG.vue?vue&type=script&lang=js&"
export * from "./UnitKLNG.vue?vue&type=script&lang=js&"
import style0 from "./UnitKLNG.vue?vue&type=style&index=0&id=1877d8ff&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877d8ff",
  null
  
)

export default component.exports